import isObject from "lodash/isObject";
import assign from "lodash/assign";

export const observify = (obj, fn, scope = [], deep = true) => {
  if (!isObject(obj)) {
    return obj;
  }
  let newObj = Array.isArray(obj) ? [...obj] : assign({}, obj);

  if (deep) {
    // 深度监听
    Object.keys(obj).forEach(key => {
      newObj[key] = observify(obj[key], fn, [...scope, key]);
    });
  }

  return defineReactive(newObj, fn, scope);
};

function defineReactive(obj, fn, scope) {
  return new Proxy(obj, {
    get: (target, prop, receiver) => {
      return Reflect.get(target, prop, receiver);
    },

    set: (target, prop, value) => {
      const proxyValue = observify(value, fn, [...scope, prop]);
      const result = Reflect.set(target, prop, proxyValue);
      // 触发订阅
      fn([...scope, prop], value);
      return result;
    }
  });
}
